import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=75217ae8"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=75217ae8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75217ae8')) {
      api.createRecord('75217ae8', component.options)
    } else {
      api.reload('75217ae8', component.options)
    }
    module.hot.accept("./UserLayout.vue?vue&type=template&id=75217ae8", function () {
      api.rerender('75217ae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/UserLayout.vue"
export default component.exports